import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { useProxyContext } from '../providers/baseProxyProvider';
import { useFieldArrayMethods } from '../../../../../helpers/formManager';
import ItemUI from '../../../shared/ui/Item';

const Item = ({ entityKey, isActive, changeAction, icon }) => {
  const props = useProxyContext();

  const { getFields } = useFieldArrayMethods();

  const dispatch = useDispatch();

  const handleClick = () => {
    const index = getFields().findIndex((field) => field.key === entityKey);
    dispatch(changeAction(index));
  };

  return (
    <ItemUI
      {...props}
      iconComponent={icon}
      isActive={isActive}
      onClick={handleClick}
    />
  );
};

export default memo(Item);
